import React from 'react';
import Layout from '../../../core/layouts/main/index';
import Loading from '../../../core/layouts/main/loading/loading';
import { Tab, Tabs } from 'react-bootstrap';
import ValuesAndTaxes from './components/ValuesAndTaxes';
import Terms from './components/Terms';

export default function Settings() {
  const [loading, setLoading] = React.useState(false);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <Layout showSideOverlay={sidebarOpen}>
      <div className='content'>
      <h1 className='content-heading'>Configurações</h1>
      <Tabs defaultActiveKey="terms" id="uncontrolled-tab-example" className="mb-3">
        <Tab eventKey="terms" title="Termos e Condições">
          <Terms />
        </Tab>
        <Tab eventKey="values" title="Valores">
          <ValuesAndTaxes />
        </Tab>
      </Tabs>
      <Loading loading={loading} />
    </div>
    </Layout>
  );
};